import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — access ramp. Occupies 1x2 tiles and rises gently 0.35 m over
// the 2 m run along +Z (low end at z = -1, high end at z = +1), with low
// concrete kerbs along both sides.
const CONCRETE = "#9a9a94";
const KERB = "#8a8a85";

const RISE = 0.35;
const SLOPE = Math.atan(RISE / 2); // ~0.173 rad
const LENGTH = Math.sqrt(4 + RISE * RISE); // slope length of the 2 m run

export const accessRamp = defineModel({
  id: "access-ramp",
  batchId: "modern",
  name: "Access ramp",
  tags: ["modern", "outdoor", "structure", "ramp", "accessibility"],
  summary: "A gentle concrete access ramp rising 0.35 m over 1x2 tiles.",
  description:
    "The access ramp of the Modern Living kit: 1x2 tiles, rising a gentle " +
    "0.35 m over the 2 m run along +Z, with low kerbs along both sides. The " +
    "high end meets a raised entrance or plinth at z = +1.",
  tiles: { w: 1, h: 2 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      // Sloped deck: a rotated slab whose top runs from y~0 at z=-1 to
      // y~0.35 at z=+1 (the negative X rotation lifts the +Z end).
      {
        geometry: new THREE.BoxGeometry(1.0, 0.08, LENGTH),
        color: CONCRETE,
        position: [0, RISE / 2, 0],
        rotation: [-SLOPE, 0, 0],
      },
      // Low side kerbs following the same slope.
      {
        geometry: new THREE.BoxGeometry(0.08, 0.1, LENGTH),
        color: KERB,
        position: [-0.46, RISE / 2 + 0.09, 0],
        rotation: [-SLOPE, 0, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.08, 0.1, LENGTH),
        color: KERB,
        position: [0.46, RISE / 2 + 0.09, 0],
        rotation: [-SLOPE, 0, 0],
      },
    ];
  },
  animations: [],
});
